import React from 'react';
import { Text, Icon, Box, Flex } from 'core/components';

import ResultMenuItem from './ResultMenuItem';

function Site({ item, selected, query, IconCmp, onItemClick, ...rest }) {
  const { id, title, city, country, path } = item;
  return (
    <ResultMenuItem
      {...rest}
      selected={selected}
      onClick={() => onItemClick({ type: 'site', id, path }, 'Search Results')}
    >
      <Flex gridArea="icon" alignItems="center" justifyContent="center">
        <IconCmp iconSize={22} />
      </Flex>

      <Box gridArea="title">
        <Text className="title">{title}</Text>
      </Box>

      <Flex gridArea="rightIcon" alignItems="center" justifyContent="center">
        <Icon icon={selected ? 'key-enter' : undefined} color="#ffffff" />
      </Flex>

      <Text
        className="description"
        gridArea="description"
        muted
        small
        whiteSpace="nowrap"
        textOverflow="ellipsis"
        style={{ overflow: 'hidden' }}
      >
        {city}
        {city ? ', ' : ''}
        {country}
      </Text>
    </ResultMenuItem>
  );
}

export default Site;
